var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modalSrc)?_c('div',{class:{ image__modal: true, 'image__modal--video': _vm.isVideo },on:{"click":_vm.closeImageModal}},[_c('div',{class:[
			'image__modal__wrapper flex ',
			{ 'image__modal__wrapper--video': _vm.isVideo },
		]},[_c('Close'),(_vm.isVideo && _vm.mediaSrc)?_c('video',{staticClass:"modal-video",attrs:{"src":_vm.mediaSrc,"controls":"","playsinline":"","autoplay":"","preload":"auto"},on:{"click":function($event){$event.stopPropagation();}}}):(_vm.mediaSrc)?_c('img',{attrs:{"src":_vm.mediaSrc}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }